import React from 'react';
import Pusher from 'pusher-js';
import * as actIngredientLibrary from 'actions/ingredients/library';
import * as action from 'actions';
import { connect } from 'react-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import { browserHistory } from 'react-router';
import { isDirty, getFormValues } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  PUSHER_APP_KEY,
  INVENTORY_BUSINESS_PUSHER_CHANNEL,
  INVENTORY_CLONE_OUTLET_PUSHER_EVENT,
} from 'api/constants';
import * as actOutletPage from 'actions/outletPages/list';
import LibraryDetail from './LibraryDetail';
import LibraryImportModal from './LibraryImportModal';
import SaveToAllOutletsModal from './SaveToAllOutletsModal';
import List from './List';
import ActionBar from './ActionBar';

class Library extends React.Component {
  componentDidMount() {
    this.pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    const { id } = this.props;
    this.channel = this.pusher.subscribe(INVENTORY_BUSINESS_PUSHER_CHANNEL(id));
    this.props.dispatch(actIngredientLibrary.pageRequest());
    browserHistory.listenBefore(location => {
      if (this.props.isDirtyLibrary && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  componentDidUpdate() {
    const { dispatch, exportingIngredient } = this.props;

    if (this.channel) {
      this.channel.unbind();
    }

    if (exportingIngredient) {
      this.channel.bind('library/ingredient/export', data => {
        const { idAsyncJob } = this.props.data.ingredients.library;
        if (
          idAsyncJob &&
          data.resource_id &&
          idAsyncJob === data.resource_id &&
          data.type === 'export-done' &&
          data.success
        ) {
          dispatch(actIngredientLibrary.doneExportIngredient());
          dispatch(action.showLoadingSpinner(false));
          window.location.href = data.url_path;
          dispatch(actIngredientLibrary.setExportingIngredient(false));
        } else if (
          idAsyncJob &&
          data.resource_id &&
          idAsyncJob === data.resource_id &&
          !data.success
        ) {
          dispatch(actIngredientLibrary.errorExportIngredient(data));
          dispatch(actIngredientLibrary.setExportingIngredient(false));
        }
      });
    }

    this.channel.bind(INVENTORY_CLONE_OUTLET_PUSHER_EVENT, data => {
      dispatch(actOutletPage.checkCloningOutletOnProgress(data));
    });
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  render() {
    const {
      showImportModal,
      openRightColumn,
      libraries,
      outlets,
    } = this.props.data.ingredients.library;
    const { showLoadingSpinnerPage } = this.props.data.loadingSpinner;
    const { user } = this.props.data;
    const { search } = this.props;

    return (
      <PageWrapper>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport}
        />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={libraries.results.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Create Ingredient"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/115003462393-Cara-Membuat-Bahan-Baku "
            />
            {libraries.results.length > 0 && !showLoadingSpinnerPage && (
              <List />
            )}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <LibraryDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        {/* render modal if outletids are defined */}
        {this._renderModal() && (
          <LibraryImportModal
            show={showImportModal}
            dispatch={this.props.dispatch}
            selectedOutletIds={search.outletIds}
            business={user.business}
            outlets={outlets}
          />
        )}
        <ConfirmActionModal />
        <SaveToAllOutletsModal />
      </PageWrapper>
    );
  }

  _renderModal = () => {
    const { search } = this.props;
    return search && search.outletIds && search.outletIds.length;
  };

  _onClickExport = () => {
    const { ingredients, user } = this.props.data;
    const { library } = ingredients;
    const prefix = 'Ingredients - ';
    const { categoryId, typeInventoryId, keyword } = library.filterState;
    const formatCategory = categoryId;
    this.props.dispatch(
      actIngredientLibrary.libraryExportRequest(
        prefix,
        user.email,
        library.outlets,
        formatCategory,
        this._formatExportbyInventoryId(typeInventoryId),
        keyword
      )
    );
  };

  _formatExportbyInventoryId = inventoryId => {
    let result;
    const parseInventoryId = parseInt(inventoryId);
    if (parseInventoryId) {
      if (parseInventoryId === 1) {
        result = 'low';
      } else {
        result = 'out';
      }
    } else {
      result = 'all';
    }
    return result;
  };

  _onClickImport = () => {
    this.props.dispatch(actIngredientLibrary.showImportModal());
  };
}

function select(state) {
  // only fetch some state
  const ingredientState = state.ingredients;
  return {
    data: {
      ingredients: {
        library: ingredientState.library,
      },
      outlet: state.outlet,
      category: state.category,
      user: state.moka.user,
      loadingSpinner: state.loadingSpinner,
    },
    buttons: state.buttons,
    uploaders: state.uploaders,
    nextAction: state.confirmAction.nextAction,
    isDirtyLibrary: isDirty('library')(state),
    search: getFormValues('search')(state),
    id: state.moka.user.business.id,
    exportingIngredient: ingredientState.library.exportingIngredient,
  };
}
export default connect(select)(Library);
